module.exports = __webpack_public_path__ + "img/twitter.d0b81bd.svg";